import { temporarilyNotSupport } from '../../utils'

// 陀螺仪
export const stopGyroscope = /* @__PURE__ */ temporarilyNotSupport('stopGyroscope')
export const startGyroscope = /* @__PURE__ */ temporarilyNotSupport('startGyroscope')
export const onGyroscopeChange = /* @__PURE__ */ temporarilyNotSupport('onGyroscopeChange')
export const offGyroscopeChange = /* @__PURE__ */ temporarilyNotSupport('offGyroscopeChange')
